<template>
  <div class="result-list" v-loading="loading">
    <ul>
      <li v-for="(item,index) in historys" :key="index">
        <div class="result-box">
          <div class="result-list-left">
            <div class="result-list-left-text">
              <h3>試卷：{{ item.exam_name }}</h3>
              <el-row :gutter="20" style="margin-bottom:15px">
                <el-col :span="7"><span>試卷狀態：{{ item.status == 1 ? '已評卷' : '待評卷' }}</span></el-col>
                <el-col :span="4"><span>得分：{{ item.status ? item.score : '--' }}</span></el-col>
                <el-col :span="5"><span>評定：{{ judge(item) }}</span></el-col>
                <el-col :span="4"><span>總題數：{{ questions.length }}</span></el-col>
                <el-col :span="4"><span>錯題數：{{ item | calcWrongNumber(questions) }}</span></el-col>
              </el-row>
              <el-row :gutter="30">
                <el-col :span="12"><span>開始考試時間：{{ item.start_time }}</span></el-col>
                <el-col :span="12"><span>結束考試時間：{{ item.end_time }}</span></el-col>
              </el-row>
            </div>
          </div>
          <div v-if="$route.query.details == 1" class="result-list-right">
            <el-button :type="item.status ? 'primary' : 'info'" :disabled="item.status ? false : true" @click="goResult(item)">詳情</el-button>
          </div>
        </div>
        <el-divider></el-divider>
      </li>
    </ul>
    <Empty v-if="historys.length === 0" title="暫無結果" :img="require('@p/assets/images/resultEmpty.png')" />
  </div>
</template>
<script>
import Empty from '@p/components/contentEmpty';

export default {
  components: { Empty },
  data () {
    return {
      loading: false,
      historys: [],
      passcore: 60,
      questions: []
    }
  },
  created () {
    this.achievementList()
  },
  methods: {
    async achievementList () {
      this.loading = true;
      await this.$http.examination.achievementList({ exam_id: this.$route.query.exam_id, examination_id: this.$route.query.examination_id }).then(v => {
        if (v.status === 200 && v.data.status_code === 200) {
          this.historys = v.data.data.history;
          this.passcore = v.data.data.passcore;
          this.questions = v.data.data.question;
        }
        this.loading = false;
      }).catch(er => { this.loading = false; })
    },
    judge (item) {
      if (item.status) {
        return item.score >= this.passcore ? '合格' : '不合格';
      } else {
        return "--";
      }
    },
    goResult (item) {
      this.$router.push({ path: '/exam/result', query: { exam_id: this.$route.query.exam_id, examination_id: this.$route.query.examination_id, history_id: item.id, title: this.$route.query.title, status: this.$route.query.status } })
    }
  },
  filters: {
    calcWrongNumber (history, questions) {
      if (!history.status) {
        return "--";
      } else if (history.errorQuestionCount != null) {
        return history.errorQuestionCount;
      }
      const answer = history.answer;
      const answerObj = JSON.parse(answer);
      let wrongNumber = 0;
      questions.map((question) => {
        let answerValue = answerObj[question.id];
        if (answerValue instanceof Array) {
          answerValue = answerValue.join('');
        }
        if ((question.categories == 4 || question.categories == 5) && history.lecturer_evaluation) { // 人工評卷
          const lecturer_evaluation = JSON.parse(history.lecturer_evaluation);
          const evaluation = lecturer_evaluation[question.id];
          if (evaluation.result == 0) {
            wrongNumber++;
          }
        } else {
          if (answerValue != question.answer) {
            wrongNumber++;
          }
        }
      })
      return wrongNumber;
    }
  }
}
</script>
<style lang="less" scoped>
.result-list {
  padding-bottom: 30px;
  .result-box {
    height: 103px;
    display: flex;
    justify-content: space-between;
  }
  > ul {
    margin-top: 30px;
  }
  &-left {
    display: flex;
    &-text {
      width: 550px;
      padding-left: 20px;
      h3 {
        color: #404040;
        font-size: 16px;
        margin-bottom: 10px;
      }
      span {
        line-height: 18px;
        font-size: 13px;
        color: rgba(51, 51, 51, 0.5);
      }
    }
  }
  &-right {
    display: flex;
    align-items: center;
    .el-button {
      width: 100px;
      span {
        font-size: 14px;
      }
    }
  }
}
</style>